import { Divider, Heading, SimpleGrid, VStack } from '@chakra-ui/react'
import { Control } from 'react-hook-form'
import type {
  PropertyFormInput,
  PropertyFormOutput,
} from '../../../../../schemas/propertySchema'
import {
  FormInput,
  FormTextarea,
  FormTimeInput,
} from '../../../../ui/FormFields'

interface AccessInstructionsStepProps {
  control: Control<PropertyFormInput<boolean>, any, PropertyFormOutput<boolean>>
}

export function AccessInstructionsStep({
  control,
}: AccessInstructionsStepProps) {
  return (
    <VStack spacing={6} align="stretch">
      {/* Access Information */}
      <VStack spacing={4} align="stretch">
        <Heading size="sm" color="gray.700">
          Informações de Acesso
        </Heading>

        <SimpleGrid columns={{ base: 1, md: 2 }} spacing={4}>
          <FormInput
            name="wifi_name"
            label="Nome da Rede Wi-Fi"
            control={control}
            placeholder="Nome da rede"
            autoComplete="off"
          />

          <FormInput
            name="wifi_password"
            label="Senha do Wi-Fi"
            control={control}
            placeholder="Senha da rede"
            type="password"
            autoComplete="new-password"
          />
        </SimpleGrid>

        <FormInput
          name="access_code"
          label="Código de Acesso"
          control={control}
          placeholder="Código da porta/portão"
        />

        <SimpleGrid columns={{ base: 1, md: 2 }} spacing={4}>
          <FormTimeInput
            name="checkin_time"
            label="Horário de Check-in"
            control={control}
          />

          <FormTimeInput
            name="checkout_time"
            label="Horário de Check-out"
            control={control}
          />
        </SimpleGrid>
      </VStack>

      <Divider />

      {/* Instructions */}
      <VStack spacing={4} align="stretch">
        <Heading size="sm" color="gray.700">
          Instruções para Hóspedes
        </Heading>

        <FormTextarea
          name="checkin_instructions"
          label="Instruções de Check-in"
          control={control}
          placeholder="Como fazer o check-in, onde pegar as chaves, etc."
          rows={4}
        />

        <FormTextarea
          name="checkout_instructions"
          label="Instruções de Check-out"
          control={control}
          placeholder="Como fazer o check-out, onde deixar as chaves, etc."
          rows={4}
        />
      </VStack>
    </VStack>
  )
}
